import { render, staticRenderFns } from "./BrandWithProducts.vue?vue&type=template&id=6c125e96&scoped=true&"
import script from "./BrandWithProducts.vue?vue&type=script&lang=js&"
export * from "./BrandWithProducts.vue?vue&type=script&lang=js&"
import style0 from "./BrandWithProducts.vue?vue&type=style&index=0&id=6c125e96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c125e96",
  null
  
)

component.options.__file = "BrandWithProducts.vue"
export default component.exports